module.exports = __webpack_public_path__ + "static/media/pic-news.70215b65.png";